import Button from '@components/common/Button';
import Checkbox from '@components/common/Checkbox';
import Link from '@components/common/Link';
import styled from 'styled-components';

/*
modal height: 90vh
top&bottom height: 10vh
title height: 5rem
actions height: 5rem
*/
export const Container = styled.div`
  width: 622px;
  max-width: 100%;
  height: calc(78vh - 15rem);
`;

export const ActionsWrap = styled.div`
  display: block;
  height: 12rem;
  padding-top: 2rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
  }
`;

export const TextContainer = styled.div<{ showOpacity?: boolean }>`
  padding-right: 32px;
  overflow-y: auto;
  height: calc(100% - 15rem);

  ${({ showOpacity }) =>
    showOpacity &&
    `
    -webkit-mask-image: linear-gradient(to bottom, black 50%, transparent 100%);
    mask-image: linear-gradient(to bottom, black 50%, transparent 100%);
  `};

  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
  }
`;

export const ParagraphContainer = styled.div``;

export const StyledCheckbox = styled(Checkbox)`
  margin-bottom: 3rem;
`;

export const AcceptButton = styled(Button)``;

export const StyledLink = styled(Link)`
  display: block;
  color: ${({
    theme: {
      colors: {
        functional: { darkestGray },
      },
    },
  }) => darkestGray};
  text-decoration: underline;
  font-weight: 500;
  margin-bottom: 4px;
`;
